<template>
  <div
    :class="[`download-archive-${mode}`, {'is-disabled': disabled, 'is-loading': loading}]"
    @click.stop="downloadArchive">
    <TooltipedBtn
      v-if="mode==='button'"
      :disabled="disabled || loading"
      icon="download"
      :loading="loading"
      :small-btn="smallBtn"
      :text="hint || $t('Common.DownloadArchive')"
      :texted="!hint && $vuetify.breakpoint.xlAndUp"
      @click.stop="downloadArchive"/>
    <sIcon
      v-else
      class="my-auto"
      :color="disabled || loading ? 'grey': ''"
      :spin="loading"
      :type="loading ? 'loading' :'download'"/>
    <slot name="default"/>
  </div>
</template>
<script>
import TooltipedBtn from 'components/common/elements/TooltipedBtn.vue'

import { findComponentsUpward, findComponentsDownward } from 'toolkit/utils/dom'
import { debounce } from 'toolkit/utils/util'
import { mapGetters } from 'vuex'
import { eventBus } from '@/main'

/**
 * Загрузка документов тендера единым архивом
 * @vue-prop {Number} tenderId - Ключ тендера
 * @vue-prop {Array} attachments - Массив документов
 * @vue-prop {String} title - Название файла
 * @vue-prop {String} label - Текст кнопки
 */
export default {
  name: 'downloadDocumentArchive',
  data() {
    return {
      key: null,
      loading: false
    }
  },
  computed: {
    ...mapGetters('notification', [ 'isActiveSignalR']),
  },
  methods: {
    /**
     * Ищем компонент с загрузкой файлов и проверяем текущее состояние
     */
    findFileList(key) {
      const defaultApp = findComponentsUpward(this, 'layout')
      if (!defaultApp?.length) {
        this.loading = false
        this.key = null
        return
      }
      const downloadFiles = findComponentsDownward(defaultApp[0], 'download-files')
      if (!downloadFiles?.length) {
        this.loading = false
        this.key = null
        return
      }
      if (downloadFiles[0].files[key]) {
        this.loading = true
        this.key = downloadFiles[0].files[key].key
      }
    },
    /**
     * Загрузка архива
     */
    downloadArchive: debounce(async function () {
      if (this.disabled || this.loading) {
        return
      }
      if (!this.isActiveSignalR) {
        eventBus.$emit('ShowSignalAlert', 'Завантаження архіву документів')
        return
      }
      const title = this.title || this.$t('Tenders.Archive')
      await this.$notifier.generateArchivedFile(title, this.tenderId, this.supplierId)
    }, 250),
    /**
     * Блокируем кнопку при совпадении параметров
     */
    disableButton(params) {
      if (params?.method !== 'generateArchivedFile') {
        return
      }
      if (params && params.tenderId === this.tenderId && params.supplierId === this.supplierId) {
        this.key = params.key
        this.loading = true
      }
    },
    /**
     * Активируем кнопку
     */
    enableButton(params) {
      if (!this.loading || !params || !params.key) { return }
      if (params.key === this.key) {
        this.loading = false
        this.key = null
      }
    }
  },
  mounted() {
    this.findFileList(`getArchivedFile-${this.tenderId}`)
    this.$root.$on('startFileDownload', this.disableButton)
    this.$root.$on('finishFileDownload', this.enableButton)
  },
  beforeDestroy() {
    this.$root.$off('startFileDownload', this.disableButton)
    this.$root.$off('finishFileDownload', this.enableButton)
  },
  props: {
    tenderId: {
      type: Number,
      require: true,
    },
    supplierId: {
      type: Number,
      require: true,
      default: null
    },
    title: {
      type: String,
      default: 'document-archive'
    },
    label: {
      type: String,
    },
    /**
     * Маленькая кнопка
     */
    smallBtn: {
      type: Boolean
    },
    disabled: {
      type: Boolean
    },
    hint: {
      type: String
    },
    mode: {
      type: String,
      default: 'button'

    }
  },
  components: {
    TooltipedBtn,
  }
}
</script>
<style scoped lang="scss">
.download-archive {
  &-icon {
    display: flex;
    &.is-disabled,
    &.is-loading {
      color: grey !important;
    }
  }
}
</style>
